import {useContext} from "react"
import {NwDashboardContext} from "../contexts/NwDashboardContext"

export function useNwDashboardContext() {
    const context = useContext(NwDashboardContext)
    if (!context) {
        throw new Error("useNwDashboardContext must be used within a NwDashboardContext")
    }
    return context
}